// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
export type WorkbookListItemFragmentFragment = {
  __typename?: "Workbook";
  id: string;
  name: string;
  description?: string | null;
  createdAt: number;
  lastActivityAt: number;
  variantsCount: number;
  draft: boolean;
  channel?: string | null;
  user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
  server: { __typename?: "Server"; id: string; humanId: string; name: string };
  database: { __typename?: "Database"; id: string; datname?: string | null };
};

export const WorkbookListItemFragmentFragmentDoc = gql`
  fragment WorkbookListItemFragment on Workbook {
    id
    name
    description
    createdAt
    lastActivityAt
    variantsCount
    draft
    user {
      id
      fullname
    }
    server {
      id
      humanId
      name
    }
    database {
      id
      datname
    }
    channel
  }
`;
